import { createContext, type ReactNode, useContext } from 'react';

const ModuleThemeContext = createContext<string | undefined>(undefined);

export function ModuleThemeProvider({
  module,
  children,
}: {
  module: string;
  children: ReactNode;
}) {
  return (
    <ModuleThemeContext.Provider value={module}>
      {children}
    </ModuleThemeContext.Provider>
  );
}

export function useModuleTheme() {
  return useContext(ModuleThemeContext);
}
